
export class TeaserTextsVO {
    public titleStr: string;
    public btnShopLabel: string;
    public btnOkLabel: string;

    public toString(): string {
        return "titleStr: " + this.titleStr + ", btnShopLabel: " + this.btnShopLabel + ", btnOkLabel: " + this.btnOkLabel;
    }
}
